// import React, { useState } from "react";
// import materials from "../data/materials";


// function StudentMaterialsPage() {
//   const [selectedMaterial, setSelectedMaterial] = useState(null);

//   return (
//     <div
//       style={{
//         padding: "40px",
//         background: "#f5f5f5",
//         minHeight: "100vh",
//       }}
//     >
//       <h1 style={{ textAlign: "center" }}>
//         🎉 Welcome to Student Materials
//       </h1>

//       <p style={{ textAlign: "center" }}>
//         You have successfully logged in.
//       </p>

//       <h2 style={{ textAlign: "center" }}>
//         Total Materials: {materials.length}
//       </h2>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
//           gap: "20px",
//           marginTop: "40px",
//         }}
//       >
//         {materials.map((material) => (
//           <div
//             key={material.id}
//             style={{
//               background: "#fff",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 2px 10px rgba(0,0,0,.1)",
//             }}
//           >
//             <h3>{material.title}</h3>

//             <p>{material.description}</p>

//             <p>
//               <b>Type:</b> {material.type}
//             </p>

//             <button
//               onClick={() => setSelectedMaterial(material)}
//               style={{
//                 background: "#2563eb",
//                 color: "#fff",
//                 border: "none",
//                 padding: "10px 18px",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//               }}
//             >
//               View
//             </button>
//           </div>
//         ))}
//       </div>

//       {/* PDF Viewer */}

//       {selectedMaterial && selectedMaterial.type === "pdf" && (
//         <div
//           style={{
//             marginTop: "40px",
//             background: "#fff",
//             padding: "20px",
//             borderRadius: "10px",
//           }}
//         >
//           <h2>{selectedMaterial.title}</h2>

//           <iframe
//             title="PDF Viewer"
//             src={selectedMaterial.file}
//             width="100%"
//             height="700"
//             style={{ border: "none" }}
//           ></iframe>

//           <br />

//           <button
//             onClick={() => setSelectedMaterial(null)}
//             style={{
//               marginTop: "20px",
//               background: "red",
//               color: "#fff",
//               border: "none",
//               padding: "10px 18px",
//               cursor: "pointer",
//             }}
//           >
//             Close
//           </button>
//         </div>
//       )}

//       {/* Video Viewer */}

//       {selectedMaterial && selectedMaterial.type === "video" && (
//         <div
//           style={{
//             marginTop: "40px",
//             background: "#fff",
//             padding: "20px",
//             borderRadius: "10px",
//           }}
//         >
//           <h2>{selectedMaterial.title}</h2>

//           <video
//             width="100%"
//             height="500"
//             controls
//             controlsList="nodownload"
//             disablePictureInPicture
//           >
//             <source
//               src={selectedMaterial.file}
//               type="video/mp4"
//             />
//           </video>

//           <br />

//           <button
//             onClick={() => setSelectedMaterial(null)}
//             style={{
//               marginTop: "20px",
//               background: "red",
//               color: "#fff",
//               border: "none",
//               padding: "10px 18px",
//               cursor: "pointer",
//             }}
//           >
//             Close
//           </button>
//         </div>
//       )}

//       {/* DOC Viewer */}

//       {selectedMaterial && selectedMaterial.type === "doc" && (
//         <div
//           style={{
//             marginTop: "40px",
//             background: "#fff",
//             padding: "20px",
//             borderRadius: "10px",
//           }}
//         >
//           <h2>{selectedMaterial.title}</h2>

//           <p>
//             Document Preview is not available.
//           </p>

//           <p>
//             Convert DOCX to PDF for secure viewing.
//           </p>

//           <button
//             onClick={() => setSelectedMaterial(null)}
//             style={{
//               marginTop: "20px",
//               background: "red",
//               color: "#fff",
//               border: "none",
//               padding: "10px 18px",
//               cursor: "pointer",
//             }}
//           >
//             Close
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default StudentMaterialsPage;
// import React, { useState } from "react";
// import materials from "../data/materials";

// import StudentHeader from "../components/StudentHeader";
// import MaterialCard from "../components/MaterialCard";

// function StudentMaterialsPage() {
//   const [selectedMaterial, setSelectedMaterial] = useState(null);

//   return (
//     <>
//       {/* Header */}
//       <StudentHeader />

//       <div
//         style={{
//           padding: "40px",
//           background: "#f5f5f5",
//           minHeight: "100vh",
//         }}
//       >
//         <h1 style={{ textAlign: "center" }}>
//           🎉 Welcome to Student Materials
//         </h1>

//         <p style={{ textAlign: "center" }}>
//           You have successfully logged in.
//         </p>

//         <h2 style={{ textAlign: "center" }}>
//           Total Materials: {materials.length}
//         </h2>

//         {/* Material Cards */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
//             gap: "20px",
//             marginTop: "40px",
//           }}
//         >
//           {materials.map((material) => (
//             <MaterialCard
//               key={material.id}
//               material={material}
//               onView={setSelectedMaterial}
//             />
//           ))}
//         </div>

//         {/* ================= PDF VIEWER ================= */}

//         {selectedMaterial && selectedMaterial.type === "pdf" && (
//           <div
//             style={{
//               marginTop: "40px",
//               background: "#fff",
//               padding: "20px",
//               borderRadius: "10px",
//               boxShadow: "0 2px 10px rgba(0,0,0,.1)",
//             }}
//           >
//             <h2>{selectedMaterial.title}</h2>

//             <iframe
//               title={selectedMaterial.title}
//               src={`${selectedMaterial.file}#toolbar=0&navpanes=0&scrollbar=0`}
//               width="100%"
//               height="700"
//               style={{ border: "none" }}
//             />

//             <button
//               onClick={() => setSelectedMaterial(null)}
//               style={{
//                 marginTop: "20px",
//                 background: "#ef4444",
//                 color: "#fff",
//                 border: "none",
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         )}

//         {/* ================= VIDEO VIEWER ================= */}

//         {selectedMaterial && selectedMaterial.type === "video" && (
//           <div
//             style={{
//               marginTop: "40px",
//               background: "#fff",
//               padding: "20px",
//               borderRadius: "10px",
//               boxShadow: "0 2px 10px rgba(0,0,0,.1)",
//             }}
//           >
//             <h2>{selectedMaterial.title}</h2>

//             <video
//               width="100%"
//               height="500"
//               controls
//               controlsList="nodownload"
//               disablePictureInPicture
//             >
//               <source
//                 src={selectedMaterial.file}
//                 type="video/mp4"
//               />
//             </video>

//             <button
//               onClick={() => setSelectedMaterial(null)}
//               style={{
//                 marginTop: "20px",
//                 background: "#ef4444",
//                 color: "#fff",
//                 border: "none",
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         )}

//         {/* ================= DOC VIEWER ================= */}

//         {selectedMaterial && selectedMaterial.type === "doc" && (
//           <div
//             style={{
//               marginTop: "40px",
//               background: "#fff",
//               padding: "20px",
//               borderRadius: "10px",
//               boxShadow: "0 2px 10px rgba(0,0,0,.1)",
//               textAlign: "center",
//             }}
//           >
//             <h2>{selectedMaterial.title}</h2>

//             <p>
//               Document preview is not supported in the browser.
//             </p>

//             <p>
//               For better security, convert DOC/DOCX files to PDF and
//               upload the PDF instead.
//             </p>

//             <button
//               onClick={() => setSelectedMaterial(null)}
//               style={{
//                 marginTop: "20px",
//                 background: "#ef4444",
//                 color: "#fff",
//                 border: "none",
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default StudentMaterialsPage;
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// import materials from "../data/materials";
// import StudentHeader from "../components/StudentHeader";
// import MaterialCard from "../components/MaterialCard";

// function StudentMaterialsPage() {

//   const navigate = useNavigate();

//   const [selectedMaterial, setSelectedMaterial] = useState(null);

//   // Logout Function
//   const handleLogout = () => {

//     localStorage.removeItem("studentAuth");
//     localStorage.removeItem("studentUser");

//     navigate("/student/login");

//   };

//   return (
//     <>
//       <StudentHeader onLogout={handleLogout} />

//       <div
//         style={{
//           padding: "40px",
//           background: "#f5f5f5",
//           minHeight: "100vh",
//         }}
//       >
//         <h1 style={{ textAlign: "center" }}>
//           🎉 Welcome to Student Materials
//         </h1>

//         <p style={{ textAlign: "center" }}>
//           You have successfully logged in.
//         </p>

//         <h2 style={{ textAlign: "center" }}>
//           Total Materials : {materials.length}
//         </h2>

//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns:
//               "repeat(auto-fit,minmax(300px,1fr))",
//             gap: "20px",
//             marginTop: "40px",
//           }}
//         >
//           {materials.map((material) => (
//             <MaterialCard
//               key={material.id}
//               material={material}
//               onView={setSelectedMaterial}
//             />
//           ))}
//         </div>

//         {/* PDF */}

//         {selectedMaterial &&
//           selectedMaterial.type === "pdf" && (
//             <div
//               style={{
//                 marginTop: "40px",
//                 background: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//               }}
//             >
//               <h2>{selectedMaterial.title}</h2>

//               <iframe
//                 title={selectedMaterial.title}
//                 src={`${selectedMaterial.file}#toolbar=0&navpanes=0`}
//                 width="100%"
//                 height="700"
//                 style={{ border: "none" }}
//               />

//               <br />

//               <button
//                 onClick={() =>
//                   setSelectedMaterial(null)
//                 }
//                 style={{
//                   marginTop: "20px",
//                   background: "red",
//                   color: "#fff",
//                   border: "none",
//                   padding: "10px 20px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           )}

//         {/* VIDEO */}

//         {selectedMaterial &&
//           selectedMaterial.type === "video" && (
//             <div
//               style={{
//                 marginTop: "40px",
//                 background: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//               }}
//             >
//               <h2>{selectedMaterial.title}</h2>

//               <video
//                 width="100%"
//                 height="500"
//                 controls
//                 controlsList="nodownload"
//                 disablePictureInPicture
//               >
//                 <source
//                   src={selectedMaterial.file}
//                   type="video/mp4"
//                 />
//               </video>

//               <br />

//               <button
//                 onClick={() =>
//                   setSelectedMaterial(null)
//                 }
//                 style={{
//                   marginTop: "20px",
//                   background: "red",
//                   color: "#fff",
//                   border: "none",
//                   padding: "10px 20px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           )}

//         {/* DOC */}

//         {selectedMaterial &&
//           selectedMaterial.type === "doc" && (
//             <div
//               style={{
//                 marginTop: "40px",
//                 background: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//               }}
//             >
//               <h2>{selectedMaterial.title}</h2>

//               <p>
//                 DOC/DOCX preview is not supported.
//               </p>

//               <p>
//                 Convert the document to PDF for secure
//                 viewing.
//               </p>

//               <button
//                 onClick={() =>
//                   setSelectedMaterial(null)
//                 }
//                 style={{
//                   marginTop: "20px",
//                   background: "red",
//                   color: "#fff",
//                   border: "none",
//                   padding: "10px 20px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           )}
//       </div>
//     </>
//   );
// }

// export default StudentMaterialsPage;
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import materials from "../data/materials";
import StudentHeader from "../components/StudentHeader";
import MaterialCard from "../components/MaterialCard";

function StudentMaterialsPage() {
  const navigate = useNavigate();
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  // Re-check auth every time this page becomes visible again
  // (fixes back/forward cache showing stale logged-in view)
  useEffect(() => {
    const checkAuth = () => {
      const isLoggedIn = localStorage.getItem("studentAuth") === "true";
      if (!isLoggedIn) {
        navigate("/student/login", { replace: true });
      }
    };

    // Runs when page is restored from bfcache (Back/Forward button)
    window.addEventListener("pageshow", checkAuth);

    return () => {
      window.removeEventListener("pageshow", checkAuth);
    };
  }, [navigate]);

  // Logout Function
  const handleLogout = () => {
    localStorage.removeItem("studentAuth");
    localStorage.removeItem("studentUser");

    navigate("/student/login", { replace: true });
  };

  return (
    <>
      <StudentHeader onLogout={handleLogout} />

      <div
        style={{
          padding: "40px",
          background: "#f5f5f5",
          minHeight: "100vh",
        }}
      >
        <h1 style={{ textAlign: "center" }}>
          🎉 Welcome to Student Materials
        </h1>

        <p style={{ textAlign: "center" }}>
          You have successfully logged in.
        </p>

        <h2 style={{ textAlign: "center" }}>
          Total Materials : {materials.length}
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
            gap: "20px",
            marginTop: "40px",
          }}
        >
          {materials.map((material) => (
            <MaterialCard
              key={material.id}
              material={material}
              onView={setSelectedMaterial}
            />
          ))}
        </div>

        {/* PDF */}
        {selectedMaterial && selectedMaterial.type === "pdf" && (
          <div
            style={{
              marginTop: "40px",
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <h2>{selectedMaterial.title}</h2>

            <iframe
              title={selectedMaterial.title}
              src={`${selectedMaterial.file}#toolbar=0&navpanes=0`}
              width="100%"
              height="700"
              style={{ border: "none" }}
            />

            <br />

            <button
              onClick={() => setSelectedMaterial(null)}
              style={{
                marginTop: "20px",
                background: "red",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        )}

        {/* VIDEO */}
        {selectedMaterial && selectedMaterial.type === "video" && (
          <div
            style={{
              marginTop: "40px",
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <h2>{selectedMaterial.title}</h2>

            <video
              width="100%"
              height="500"
              controls
              controlsList="nodownload"
              disablePictureInPicture
            >
              <source src={selectedMaterial.file} type="video/mp4" />
            </video>

            <br />

            <button
              onClick={() => setSelectedMaterial(null)}
              style={{
                marginTop: "20px",
                background: "red",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        )}

        {/* DOC */}
        {selectedMaterial && selectedMaterial.type === "doc" && (
          <div
            style={{
              marginTop: "40px",
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <h2>{selectedMaterial.title}</h2>

            <p>DOC/DOCX preview is not supported.</p>
            <p>Convert the document to PDF for secure viewing.</p>

            <button
              onClick={() => setSelectedMaterial(null)}
              style={{
                marginTop: "20px",
                background: "red",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default StudentMaterialsPage;